/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/discounts/pricerule
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDiscountCodeKey,
  ShopifyDiscountCodeToPriceRuleKey,
  ShopifyPriceRuleKey,
  ShopifyPriceRuleToDiscountCodesKey,
  ShopifyPriceRuleToShopKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyPriceRuleKey,
  "2022-01": {
    name: "Shopify Price Rule",
    fields: [
      {
        name: "Allocation Limit",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "allocation_limit" } },
      },
      {
        name: "Allocation Method",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "allocation_method" } },
      },
      {
        name: "Customer Selection",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "customer_selection" } },
      },
      {
        name: "Discount Codes",
        fieldType: FieldType.HasMany,
        key: ShopifyPriceRuleToDiscountCodesKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDiscountCodeKey,
          inverseFieldKey: ShopifyDiscountCodeToPriceRuleKey,
        },
      },
      {
        name: "Ends At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "ends_at" } },
      },
      {
        name: "Entitled Collection Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "entitled_collection_ids" } },
      },
      {
        name: "Entitled Country Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "entitled_country_ids" } },
      },
      {
        name: "Entitled Product Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "entitled_product_ids" } },
      },
      {
        name: "Entitled Variant Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "entitled_variant_ids" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Once Per Customer",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "once_per_customer" } },
      },
      {
        name: "Prerequisite Collection Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "prerequisite_collection_ids" } },
      },
      {
        name: "Prerequisite Customer Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "prerequisite_customer_ids" } },
      },
      {
        name: "Prerequisite Product Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "prerequisite_product_ids" } },
      },
      {
        name: "Prerequisite Quantity Range",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "prerequisite_quantity_range" } },
      },
      {
        name: "Prerequisite Saved Search Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "prerequisite_saved_search_ids" } },
      },
      {
        name: "Prerequisite Shipping Price Range",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "prerequisite_shipping_price_range",
          },
        },
      },
      {
        name: "Prerequisite Subtotal Range",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "prerequisite_subtotal_range" } },
      },
      {
        name: "Prerequisite To Entitlement Purchase",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "prerequisite_to_entitlement_purchase",
          },
        },
      },
      {
        name: "Prerequisite To Entitlement Quantity Ratio",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "prerequisite_to_entitlement_quantity_ratio",
          },
        },
      },
      {
        name: "Prerequisite Variants",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "prerequisite_variant_ids" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Starts At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "starts_at" } },
      },
      {
        name: "Target Selection",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "target_selection" } },
      },
      {
        name: "Target Type",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "target_type" } },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "title" } },
      },
      {
        name: "Usage Limit",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "usage_limit" } },
      },
      {
        name: "Value",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "value" } },
      },
      {
        name: "Value Type",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "value_type" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyPriceRuleToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "priceRule" },
  },
  "2022-04": {
    fields: [
      {
        name: "Prerequisite Saved Search Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "prerequisite_saved_search_ids" } },
        isDeleted: true,
      },
      {
        name: "Customer Segment Prerequisite Ids",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "customer_segment_prerequisite_ids" } },
      },
    ],
  },
  "2025-04": {
    isDisconnected: true,
  },
};

export const ShopifyPriceRule = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
